module.exports = __webpack_public_path__ + "static/media/help-center-header.c563f22c.jpg";